<ng-container *ngIf="loaded; else loading">
  <span *ngIf="showIsStartingAt" class="starting-at">
    {{ 'FRONTEND.STORE.STARTING_AT' | translate }}
  </span>
  <div *ngIf="hasVerifiedContract && billedProduct; else usePricing">
    <div
      class="price-container"
      *ngIf="isFlatPrice$ | async; else notFlatPrice"
    >
      <div class="price">
        {{ (pricingTierData$ | async)[0]?.priceStringForTier }}
      </div>
    </div>
    <ng-template #notFlatPrice>
      <ng-container *ngIf="isFirstTierFree$ | async; else firstTierNotFree">
        <div class="starting-at-caption">Starting at</div>
        {{ 'FRONTEND.STORE.FREE' | translate }}
        <mat-icon
          class="tooltip-icon"
          (mouseenter)="itemInfoIconEnter()"
          (mouseleave)="itemInfoIconLeave()"
          [glxyPopover]="pricingPopover"
        >
          info_outline
        </mat-icon>

        <glxy-popover
          #pricingPopover
          [isOpen]="showPricingPopover"
          [hasArrow]="true"
          [positions]="[]"
          [padding]="'large'"
          [maxWidth]="'auto'"
        >
          <div class="pricing-popover-content">
            <div class="discounts-title">
              {{
                'FRONTEND.TABLE_PRICING.WHOLESALE_PRICING_INFORMATION'
                  | translate
              }}
            </div>

            <div class="popover-price-container">
              <div
                class="pricing-tier"
                *ngFor="let tier of pricingTierData$ | async"
              >
                <div class="pricing-tier__range">
                  {{ tier.pricingTierString }}
                </div>
                <div class="pricing-tier__price">
                  {{ tier.priceStringForTier }}
                </div>
              </div>
              <div class="pricing-tier" *ngIf="billedProduct?.setupFee > 0">
                <div class="pricing-tier__range"></div>
                <div class="pricing-tier__price">
                  +
                  {{
                    billedProduct.setupFee
                      | price$: billedProduct.currency
                      | async
                  }}
                  {{ setupFeeString$ | async }}
                </div>
              </div>
            </div>

            <div *ngIf="discounts$ | async as discounts" class="discounts">
              <div *ngIf="discounts.length">
                <span class="discounts-title">
                  {{ 'FRONTEND.TABLE_PRICING.ACTIVE_DISCOUNTS' | translate }}
                </span>
              </div>
              <ul class="discount-list">
                <li *ngFor="let disc of discounts">
                  {{ disc | formatDiscount: billedProduct?.currency }}
                </li>
              </ul>
            </div>
          </div>
        </glxy-popover>
      </ng-container>

      <ng-template #firstTierNotFree>
        <div class="price-container--tiered">
          <div
            class="pricing-tier"
            *ngFor="let tier of pricingTierData$ | async"
          >
            <div class="pricing-tier__range">{{ tier.pricingTierString }}</div>
            <div class="pricing-tier__price">
              {{ tier.priceStringForTier }}
            </div>
          </div>
          <div class="pricing-tier" *ngIf="billedProduct?.setupFee > 0">
            <div class="pricing-tier__range"></div>
            <div class="pricing-tier__price">
              +
              {{
                billedProduct.setupFee | price$: billedProduct.currency | async
              }}
              {{ setupFeeString$ | async }}
            </div>
          </div>
        </div>
      </ng-template>
    </ng-template>
    <div
      class="setupFee"
      *ngIf="billedProduct?.setupFee > 0 && isFlatPrice$ | async"
    >
      + {{ billedProduct.setupFee | price$: billedProduct.currency | async }}
      {{ setupFeeString$ | async }}
    </div>
    <div
      class="commitment"
      *ngIf="
        billedProduct &&
        billedProduct.commitment &&
        billedProduct.commitment.initial > 1
      "
    >
      {{ commitmentMessage$ | async }}
    </div>
  </div>
  <ng-template #usePricing>
    <div class="gray-font">
      <ng-container *ngIf="shouldContactSales$ | async; else dontContactSales">
        {{ 'FRONTEND.STORE.CONTACT_SALES' | translate }}
      </ng-container>
      <ng-template #dontContactSales>
        <ng-container *ngIf="isFree$ | async; else notFree">
          {{ 'FRONTEND.STORE.FREE' | translate }}
        </ng-container>
        <ng-template #notFree>
          <ng-container *ngIf="priceData$ | async as priceDatas">
            <ng-container *ngIf="showAllPrices">
              <ng-container
                *ngFor="let priceData of priceDatas; let first = first"
              >
                <span
                  *ngIf="first"
                  [ngClass]="{ first: priceDatas.length > 1 }"
                >
                  {{ priceData.priceStringForPricingWithFrequency }}
                </span>
                <span *ngIf="!first">
                  + {{ priceData.priceStringForPricingWithFrequency }}
                </span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!showAllPrices">
              {{ priceDatas[0].priceStringForPricingWithFrequency }}
            </ng-container>
          </ng-container>
          <div class="setupFee" *ngIf="billedProduct?.setupFee > 0">
            +
            {{
              billedProduct.setupFee | price$: billedProduct.currency | async
            }}
            {{ setupFeeString$ | async }}
          </div>
          <div
            class="commitment"
            *ngIf="
              billedProduct &&
              billedProduct.commitment &&
              billedProduct.commitment.initial > 1
            "
          >
            {{ commitmentMessage$ | async }}
          </div>
        </ng-template>
      </ng-template>
    </div>
  </ng-template>
</ng-container>
<ng-template #loading>
  <div class="stencil-pricing stencil-shimmer"></div>
</ng-template>
